// 套餐type枚举
export let packageTypes = [
  {
    label: '基础套餐',
    value: 'DEFAULT_WHOLE_GENOM'
  }, {
    label: '常见疾病',
    value: 'DEFAULT_COMMON_DISEASES'
  }, {
    label: '遗传病',
    value: 'DEFAULT_GENETIC_DISEASES'
  }, {
    label: '罕见病',
    value: 'DEFAULT_RARE_DISEASES'
  }, {
    label: '家系',
    value: 'DEFAULT_PEDIGREE'
  }, {
    label: '启源',
    value: 'DEFAULT_ORIGIN'
  }, {
    label: '药物基因组',
    value: 'DEFAULT_PHARMACOGENOMICS'
  }, {
    label: '个人特质',
    value: 'DEFAULT_PERSONAL_CHARACTER'
  }, {
    label: '一级分类套餐',
    value: 'DEFAULT_LEVEL_1'
  }, {
    label: '二级分类套餐',
    value: 'DEFAULT_LEVEL_2'
  }, {
    label: '自建套餐',
    value: 'CUSTOMER'
  }
]
